export const FeaturePermission = {
    LAYER_AREA_CLIENT: {
        enable: 'layer-area-client-enable',
        selectArea: 'layer-area-client-select-area',
        filterSaleType: 'layer-area-client-filter-sales-type',
        filterSaleChannel: 'layer-area-client-filter-sales-channel',
        filterSegment: 'layer-area-client-filter-segment',
        filterBrand: 'layer-area-client-filter-brand',
        filterFuelType: 'layer-client-area-filter-fuel-type',
        changePeriod: 'layer-area-client-change-period',
        showPointSelected: 'layer-area-client-show-point-selected',
        filterSelectedAreas: 'layer-area-client-filter-selected-areas',
        filterNearestSelectedAreas: 'layer-area-client-filter-neares-selected-areas',
        showName: 'layer-area-client-show-name',
        showValueTheme: 'layer-area-client-value-theme',
        editLabel: 'layer-area-client-edit-label',
        filterCompanySize: 'layer-area-client-filter-company-size',
        filterGroup: 'layer-area-client-filter-by-group-area',
        filterTypeSaleClassification: 'layer-area-client-filter-type-sale-classification',
        showAdditionalArea: 'layer-area-client-show-additional-area',
    },

    LAYER_SELECTED_AREA: {
        exportDataPanel: 'layer-locale-export-data-panel',
        manualColorful: 'layer-manual-colorful-enable',
    },

    LAYER_AREA_DEALER: {
        enable: 'layer-area-dealer-enable',
        selectArea: 'layer-type-area-dealer-select-area'
    },

    LAYER_CUSTOMER: {
        enable: 'layer-customer-enable',
        filterUf: 'layer-customer-filter-uf',
        filterGroup: 'layer-customer-filter-group',
        filterDealer: 'layer-customer-filter-dealer',
        filterFuelType: 'layer-customers-filter-fuel-type',
        filterSegment: 'layer-customers-filter-segment',
        filterSaleType: 'layer-customers-filter-sale-type',
        showDataPanel: 'layer-customer-show-data-panel',
        exportDataPanel: 'layer-customer-export-data-panel-table',
        changePeriod: 'layer-customer-change-period',
        showGroupClient: 'layer-customer-show-group-client'
    },

    LAYER_CLUSTER_SALES: {
        enable: 'layer-cluster-sales-enable',
        filterSegment: 'layer-cluster-sales-filter-segment',
        filterBrand: 'layer-cluster-sales-filter-brand',
        filterGroup: 'layer-cluster-sales-filter-group',
        filterFuelType: 'layer-cluster-sales-filter-fuel-type',
        showDataPanel: 'layer-cluster-sales-show-data-panel',
        exportDataPanel: 'layer-cluster-sales-export-data-panel',
        changePeriod: 'layer-cluster-sales-change-period'
    },

    LAYER_DNC: {
        enable: 'layer-dnc-enable',
        changePeriod: 'layer-dnc-change-period',
        exportData: 'layer-dnc-export-data',
        filterSegment: 'layer-dnc-filter-segment',
        companySize: 'layer-dnc-filter-company-size',
        salesChannel: 'layer-dnc-filter-sales-channel'
    },

    LAYER_GREENFIELD: {
        enable: 'layer-greenfield-enable',
        filterType: 'layer-greenfield-filter-type'
    },

    LAYER_NEW_GREENFIELD: {
        enable: 'new-layer-greenfield-enable',
        filterType: 'new-layer-greenfield-filter-type'
    },

    LAYER_BROWNFIELD: {
        enable: 'layer-brownfield-enable',
        filterType: 'layer-brownfield-filter-type'
    },

    LAYER_LOCALES: {
        enable: 'layer-locale-enable',
        enableDga: 'location-type-gm-dga',
        selectArea: 'layer-locale-select-area',
        selectTheme: 'layer-locale-select-theme',
        filterSaleType: 'layer-locale-filter-sale-type',
        filterSaleChannel: 'layer-locale-filter-sale-channel',
        filterSegment: 'layer-locale-filter-segment',
        filterBrand: 'layer-locale-filter-brand',
        filterFuelType: 'layer-locale-filter-fuel-type',
        changePeriod: 'layer-locale-change-period',
        showNearestPointSelectedArea: 'layer-locale-show-neares-point-selected-area',
        filterIntersectsArea: 'layer-locale-filter-intersects-areas',
        showName: 'layer-locale-show-name',
        showValue: 'layer-locale-show-value',
        filterSelectedArea: 'layer-locale-filter-selected-areas',
        filterCompanySize: 'layer-locale-filter-company-size',
        filterTypeSaleClassification: 'layer-locale-filter-type-sale-classification',
        filterSpecializationIndustry: 'layer-locale-filter-specialization-industry',
    },

    LAYER_POINT_INTEREST: {
        enable: 'layer-interest-point-enable'
    },

    LAYER_NETWORK: {
        enable: 'layer-network-enable',
        filterBrand: 'layer-network-filter-brand',
        filterStoreType: 'layer-network-filter-store-type',
        filterGroup: 'layer-network-filter-group',
        filterSegment: 'layer-network-filter-segment',
        filterFuelType: 'layer-network-filter-fuel-type',
        filterUf: 'layer-network-filter-uf',
        filterStoreTypeSaleMarket: 'layer-network-filter-store-type-sale-market',
        filterStoreAttribute: 'layer-network-filter-store-attribute',
        filterInfluenceArea: 'layer-network-filter-influence-area',
        showDataPanel: 'layer-network-show-data-panel',
        exportDataPanel: 'layer-network-export-data-panel',
        showVmm: 'layer-network-show-vmm',
        changePeriod: 'layer-network-change-period-vmm',
        showName: 'layer-network-show-name',
        editOption: 'layer-network-point-edit',
        recalculateOption: 'layer-network-point-edit-area',
        showGroup: 'layer-network-show-group',
        showGroupClient: 'layer-network-show-group-client',
        showSmallestPins: 'layer-network-show-smallest-pins',
    },

    LAYER_STORES_MOTOCYCLE: {
        enable: 'layer-stores-motocycle-enable',
        filterBrand: 'layer-stores-motocycle-brand',
        filterStoreType: 'layer-stores-motocycle-store-type',
        filterGroup: 'layer-stores-motocycle-group',
        filterUf: 'layer-stores-motocycle-uf',
        showVmm: 'layer-stores-motocycle-show-vmm',
        changePeriod: 'layer-stores-motocycle-change-period-vmm',
        showName: 'layer-stores-motocycle-show-name',
    },

    LAYER_STORES_CONSORTIUM: {
        enable: 'layer-stores-consortium-enable',
        filterGroup: 'layer-stores-consortium-filter-group',
        filterUf: 'layer-stores-consortium-filter-uf',
        showGroup: 'layer-stores-consortium-show-group',
    },

    LAYER_STORE_INACTIVE: {
        enable: 'layer-network-inactive-enable',
        filterStoreType: 'layer-network-inactive-filter-store-type',
        filterGroup: 'layer-network-inactive-filter-group',
        filterUf: 'layer-network-inactive-filter-uf',
        showName: 'layer-network-inactive-show-name',
    },

    LAYER_COMPETITORS: {
        enable: 'layer-competitor-enable',
        filterClassification: 'layer-competitor-filter-classification',
        filterFuelType: 'layer-competitor-filter-fuel-type',
        filterBrand: 'layer-competitor-filter-brand',
        filterStoreType: 'layer-competitor-filter-store-type',
        filterGroup: 'layer-competitor-filter-group',
        filterUf: 'layer-competitor-filter-uf',
        filterSegment: 'layer-competitor-filter-segment',
        filterStoreAttribute: 'layer-competitor-filter-store-attribute',
        showDataPanel: 'layer-competitor-show-data-panel',
        exportDataPanel: 'layer-competitor-export-data-panel',
        showVmm: 'layer-competitor-show-vmm',
        changePeriodVmm: 'layer-competitor-change-period-vmm',
        showName: 'layer-competitor-show-name',
        editOption: 'layer-competitor-point-edit',
        recalculateOption: 'layer-competitor-point-edit-area',
        filterStoreTypeSaleMarket: 'layer-competitor-filter-store-type-sale-market',
        showSmallestPins: 'layer-competitor-show-smallest-pins',
    },

    LAYER_UNAPPROVED_STORES: {
        enable: 'layer-unapproved-stores-enable',
        showProtectArea: 'layer-unapproved-stores-protect-area',
    },

    LAYER_PLANNED_STORES: {
        enable: 'layer-planned-stores-enable',
    },

    LAYER_MALL_CENTERS: {
        enable: 'layer-mall-centers-enable',
        filterSegment: 'layer-mall-centers-filter-segment',
        filterBrand: 'layer-mall-centers-filter-brand',
        filterGroup: 'layer-mall-centers-filter-group',
        filterFuelType: 'layer-mall-centers-filter-fuel-type',
        changePeriod: 'layer-mall-centers-change-period'
    },

    LAYER_DIRECT_SALE: {
        enable: 'layer-direct-sale-enable',
        filterSaleChannel: 'layer-direct-sale-filter-sale-channel',
        filterSegment: 'layer-direct-sale-filter-segment',
        filterBrand: 'layer-direct-sale-filter-brand',
        filterGroup: 'layer-direct-sale-filter-group',
        filterDealer: 'layer-direct-sale-filter-dealer',
        filterFuelType: 'layer-direct-sale-filter-fuel-type',
        changePeriod: 'layer-direct-sale-change-period',
        showDataPanel: 'layer-direct-sale-show-data-panel',
        exportDataPanel: 'layer-direct-sale-export-data-panel'
    },

    LAYER_VORONOI: {
        enable: 'layer-voronoi-enable',
        selectTheme: 'layer-voronoi-select-theme',
        showPointWithinArea: 'layer-voronoi-show-point-within-areas',
        filterSelectedArea: 'layer-voronoi-filter-selected-areas',
        filterIntersectArea: 'layer-voronoi-filter-intersect-area',
        showName: 'layer-voronoi-show-name',
        showValue: 'layer-voronoi-show-value',
        showGroupClient: 'layer-voronoi-show-name-group-client'
    },

    LAYER_GENERAL: {
        gasStationEnable: 'layer-gas-station-enable',
        filterFuelType: 'layer-fuelstation-filter-fuel-type',
        filterEletricType: 'layer-fuelstation-filter-eletric-type',
        tollEnable: 'layer-toll-enable',
        pgtsEnable: 'layer-pgts-enable',
        pgtsFilter: 'layer-pgts-filter',
        pgtsFilterSizeCompany: 'layer-pgts-filter-size-company',
        farmMachineEnable: 'layer-farm-machine-enable'
    },

    LAYER_WORKSHOP_PART: {
        enable: 'layer-workshop-part-enable',
        viewWorkshop: 'layer-workshop-part-workshop-view',
        viewAutoParts: 'layer-workshop-part-autoparts-view',
        viewAcdelco: 'layer-workshop-part-acdelco-view',
        viewAccioly: 'layer-workshop-part-accioly-view',
        export: 'layer-workshop-part-export'
    },

    // ===================== NEOGIG AFTER SALES =====================
    AFTER_SALES_SUMMARY_INFO: {
        show: 'after-sales-info-summary-show',
        showRanking: 'after-sales-info-summary-show-ranking',
        showRankingBrand: 'after-sales-info-summary-show-ranking-brand',
        showVehicleFleetBrand: 'after-sales-info-summary-show-vehiclefleet-brand',
        export: 'after-sales-summary-info-export'
    },

    LAYER_AFTER_SALES_NETWORK: {
        enable: 'layer-after-sales-network-after-sales-enable',
        filterServiceType: 'layer-after-sales-network-after-sales-filter-service-type',
        filterNetworkType: 'layer-after-sales-network-after-sales-filter-network-type',
        showProtectArea: 'layer-after-sales-network-after-sales-protect-area',
        showScoreAutoParts: 'layer-after-sales-network-score-auto-parts',
        showScoreTireTruck: 'layer-after-sales-network-score-tire-truck',
        showScoreTireRetail: 'layer-after-sales-network-score-tire-retail',
        showServiceArea: 'layer-after-sales-network-after-sales-service-area',
        export: 'layer-network-after-sales-export',
        changeTitleOfChartsAndFilters: 'layer-network-after-sales-change-title-filters-charts',
    },

    LAYER_AFTER_SALES_DEALERSHIP: {
        enable: 'layer-after-sales-dealership-after-sales-enable',
        showProtectArea: 'layer-after-sales-dealership-after-sales-protect-area'
    },

    LAYER_AFTER_SALES_CUSTOMER: {
        enable: 'layer-after-sales-customer-enable',
        filterUf: 'layer-after-sales-customer-filter-uf',
        showDataPanel: 'layer-after-sales-customer-show-data-panel',
        exportDataPanel: 'layer-after-sales-customer-export-data-panel-table',
        filterLast12Months: 'layer-after-sales-customer-filter-12-last-months'
    },

    LAYER_AFTER_SALES_AREA_DEALER: {
        enable: 'layer-after-sales-area-dealer-enable',
        selectArea: 'layer-type-after-sales-area-dealer-select-area'
    },

    LAYER_AFTER_SALES_STORE_INACTIVE: {
        enable: 'layer-after-sales-network-inactive-enable',
        filterStoreType: 'layer-network-inactive-filter-store-type',
        filterUf: 'layer-network-inactive-filter-uf',
        showName: 'layer-network-inactive-show-name',
    },

    LAYER_AFTER_SALES_AREA_CLIENT: {
        enable: 'layer-after-sales-area-client-enable',
        selectArea: 'layer-after-sales-area-client-select-area',
        filterSaleType: 'layer-after-sales-area-client-filter-sales-type',
        filterSaleChannel: 'layer-after-sales-area-client-filter-sales-channel',
        filterSegment: 'layer-after-sales-area-client-filter-segment',
        filterBrand: 'layer-after-sales-area-client-filter-brand',
        filterFuelType: 'layer-client-area-filter-fuel-type',
        changePeriod: 'layer-after-sales-area-client-change-period',
        showPointSelected: 'layer-after-sales-area-client-show-point-selected',
        filterSelectedAreas: 'layer-after-sales-area-client-filter-selected-areas',
        filterNearestSelectedAreas: 'layer-after-sales-area-client-filter-neares-selected-areas',
        showName: 'layer-after-sales-area-client-show-name',
        showValueTheme: 'layer-after-sales-area-client-value-theme',
        editLabel: 'layer-after-sales-area-client-edit-label',
        filterCompanySize: 'layer-after-sales-area-client-filter-company-size'
    },

    LAYER_AFTER_SALES_MULTICRITERIA: {
        enable: 'layer-after-sales-multicriteria-enable',
        export: 'layer-after-sales-multicriteria-export',
        showScoreTireRetail: 'layer-after-sales-multicriteria-show-score-tire-retail',
        showScoreTireTruck: 'layer-after-sales-multicriteria-show-score-tire-truck',
        showScoreAutoparts: 'layer-after-sales-multicriteria-show-score-autoparts',
        showClassificationFilter: 'layer-after-sales-multicriteria-show-classification-filter',
    },

    LAYER_AFTER_SALES_TERRITORIAL_BOUNDARIES: {
        enable: 'layer-after-sales-territorial-boundaries-enable',
        selectArea: 'layer-after-sales-territorial-boundaries-select-area',
        selectTheme: 'layer-after-sales-territorial-boundaries-select-theme',
        filterSaleType: 'layer-after-sales-territorial-boundaries-filter-sale-type',
        filterSaleChannel: 'layer-after-sales-territorial-boundaries-filter-sale-channel',
        filterSegment: 'layer-after-sales-territorial-boundaries-filter-segment',
        filterBrand: 'layer-after-sales-territorial-boundaries-filter-brand',
        filterFuelType: 'layer-after-sales-territorial-boundaries-filter-fuel-type',
        changePeriod: 'layer-after-sales-territorial-boundaries-change-period',
        showNearestPointSelectedArea: 'layer-after-sales-territorial-boundaries-show-neares-point-selected-area',
        filterIntersectsArea: 'layer-after-sales-territorial-boundaries-filter-intersects-areas',
        showName: 'layer-after-sales-territorial-boundaries-show-name',
        showValue: 'layer-after-sales-territorial-boundaries-show-value',
        filterSelectedArea: 'layer-after-sales-territorial-boundaries-filter-selected-areas',
        filterCompanySize: 'layer-after-sales-territorial-boundaries-filter-company-size',
        filterEngineType: 'layer-after-sales-territorial-boundaries-filter-engine-type',
    },

    LAYER_AFTER_SALES_COMPETITORS: {
        enable: 'layer-after-sales-competitors-enable',
        filterDealerType: 'layer-after-sales-competitors-filter-dealer-type',
        filterNetwork: 'layer-after-sales-competitors-filter-network',
        filterNetworkType: 'layer-after-sales-competitors-filter-network-type',
        filterBrand: 'layer-after-sales-competitors-filter-brand',
        filterNetworkSize: 'layer-after-sales-competitors-filter-network-size',
        export: 'layer-after-sales-competitors-export',
    },

    LAYER_AFTER_SALES_CLIENT_SALES: {
        enable: 'layer-after-sales-client-sales-enable',
        filter: 'layer-after-sales-client-sales-filter-enable',
        filterSalesType: 'layer-after-sales-client-sales-filter-sales-type',
        filterLast12Months: 'layer-after-sales-client-sales-filter-12-last-months',
    },

    LAYER_AFTER_SALES_COMPANY_CUSTOMERS_POTENTIAL: {
        enable: 'layer-after-sales-company-customers-potential-enable',
        filter: 'layer-after-sales-company-customers-potential-filter-enable',
    },

    LAYER_AFTER_SALES_SERVICE_AREA: {
        enable: 'layer-after-sales-service-area-enable'
    },

    // ===================== NEOGIG AFTER SALES =====================

    // ===================== INFO =====================

    SYSTEM: {
        loadSession: 'system-load-session',
        changePassword: 'system-change-password',
        changeBrand: 'system-change-brand',
        filterSearch: 'system-filter-search',
        search: 'system-search',
        support: 'system-support',
        manual: 'system-manual',
        tour: 'system-tour',
        compareMaps: 'system-compare-maps',
        imageCapture: 'system-image-capture',
        saveSession: 'system-save-session',
        showNeodash: 'system-show-neodash',
        showControlPanel: 'system-control-panel',
        showDataRetail: 'system-data-retail',
        showDataDirect: 'system-data-direct',
        showDataTotal: 'system-data-total',
    },

    INFO_STORE: {
        enable: 'info-store-enable',
        export: 'info-store-export',
        showReport: 'info-store-show-report',
        showImage: 'info-store-show-image',
        showSaleChartMonthly: 'info-store-show-sale-chart-monthly',
        exportSaleTableMonthly: 'info-store-export-sale-table-monthly',
        showSaleChartAnnual: 'info-store-show-sale-chart-annual',
        exportSaleChartAnnual: 'info-store-export-sale-table-annual',
        showSatisfactionCustomerTable: 'info-store-show-satisfaction-customer-table',
        exportSatisfactionCustomerTable: 'info-store-export-satisfaction-customer-table'
    },

    INFO_SUMMARY: {
        show: 'info-summary-show',
        changePeriod: 'info-summary-change-period',
        showMme: 'info-summary-show-mme',
        exportMme: 'info-summary-export-mme',
        showEvaluationPeriod: 'info-summary-show-evaluation-period',
        exportEvaluationPeriod: 'info-summary-export-evaluation-period',
        showExtendTableInvasion: 'info-summary-show-extend-table-invasion',
        filterExtendTableInvasion: 'info-summary-filter-sale-type-extend-table-invasion',
        showDemography: 'info-summary-show-demography',
        showExtendTableMktShare: 'info-summary-show-extend-table-mkt-share',
        exportExtendTableMktShare: 'info-summary-export-extend-table-mkt-share',
        showExtendTableRanking: 'info-summary-show-extend-table-ranking',
        filterSaleExtendTableRanking: 'info-summary-filter-sale-extend-table-ranking',
        filterChannelExtendTableRanking: 'info-summary-filter-channel-extend-table-ranking',
        exportExtendTableRanking: 'info-summary-export-extend-table-ranking',
        showRegistrationSegmentChart: 'info-summary-show-registration-segment-chart',
        exportDataSegments: 'info-summary-export-data-segments',
        showExtendTableSegment: 'info-summary-show-extend-table-segment',
        filterSaleExtendTableSegment: 'info-summary-filter-sale-extend-table-segment',
        exportExtendTableSegment: 'info-summary-export-extend-table-segment',
        showRegistrationMktShare: 'info-summary-show-registration-mkt-share-values',
        showRetentionData: 'info-summary-show-retention-data',
        showMakerData: 'info-summary-show-maker-data',
        exportMakerData: 'info-summary-export-make-data',
        export: 'info-summary-export',
        exportTableInvasion: 'info-summary-export-data-invasion-indicator',
        filterCompanySize: 'info-summary-filter-company-size',
        showGroupClient: 'info-summary-show-group-client'
    },

    // ===================== MAP =====================

    MAP: {
        changeMapType: 'layer-map-change-type',
        toolSelectShape: 'tool-select-shape',
        toolSelectArea: 'tool-select-area',
        toolSelectDataLayer: 'tool-select-data-layer',
        toolFilterSaleType: 'tool-select-filter-sale-type',
        toolShowGroupClient: 'tool-select-show-group-client'
    },

    MAP_STORE: {
        route: 'map-store-route',
        reportChange: 'map-store-report-change',
        influenceArea: 'map-store-influence-area',
        showClients: 'map-store-show-clients',
        showRetention: 'map-store-show-retention',
        showInfo: 'map-store-show-info'
    },

    MAP_GREENFIELD: {
        route: 'map-greenfield-route'
    },

    MAP_NEW_GREENFIELD: {
        route: 'new-map-greenfield-route'
    },

    MAP_BROWNFIELD: {
        route: 'map-brownfield-route'
    },

    MAP_POINT_INTEREST: {
        route: 'map-interest-point-route',
        create: 'map-interest-point-create',
        editOption: 'map-interest-point-edit',
        deleteOption: 'map-interest-point-delete',
        recalculateOption: 'map-interest-point-edit-area',
        exportPoints: 'map-interest-points-export'
    },

    MAP_THEME: {
        marketShare: 'map-theme-market-share-view',
        registrationIndustry: ' ',
        registrationBrand: 'map-theme-registration-brand-view',
        incomeConcentration: 'map-theme-income-concentration-view',
        expansaion2020: 'map-theme-expansion-2020-view',
        openPoint: 'map-theme-open-point-view',
        drugStore: 'map-theme-drugstore-view',
        ipcAuto: 'map-theme-ipc-auto-view',
        locationName: 'map-theme-location-name',
        invasionIndicator: 'map-theme-invasion-indicator',
        registrationDealer: 'map-theme-dealer-registration',
        mktShareDealer: 'map-theme-dealer-mkt-share',
        dncDrd: 'map-theme-dnc-expansion-view',
        dncSales: 'map-theme-dnc-sales-view',
        salesBrand: 'map-theme-voronoi-sales-brand-view'
    },

    MAP_LOCALE_TYPE: {
        country: 'location-type-general-country',
        region: 'location-type-general-region',
        state: 'location-type-general-uf',
        city: 'location-type-general-county',
        neighborhood: 'location-type-general-neighborhood',
        district: 'location-type-general-district',
        subdistrict: 'location-type-general-subdistrict',
        mesoRegion: 'location-type-general-mesorregiao',
        microRegion: 'location-type-general-microregiao',
        metropole: 'location-type-general-metropolitana',
        centerCity: 'location-type-general-center-city'
    },

    MAP_ROUTES: {
        freeRouting: 'map-route-free-generate',
        NearestOperationalAreas: 'map-route-area-download',
        NearestStores: 'map-route-store-download',
        NearestSameBrandStores: 'map-route-brand-store-download'
    },
};



// WEBPACK FOOTER //
// ./src/constants/feature.permission.helper.js